module.exports = __webpack_public_path__ + "img/noticia-22.5b4530ac.jpg";